import { updatePageProps } from '@eventbrite/datalayer-library';
import { getWindowObject } from '@eventbrite/feature-detection';
import { LOCATION_CHANGE } from 'react-router-redux';
import { AnyAction, Dispatch, Store } from 'redux';
import { getEventId } from '../selectors/event';
import { getOrderPersistentId } from '../selectors/order';
import { CheckoutState } from '../state';
import { DATALAYER_MIDDLEWARE_LOCATION_CHANGE_EVENT_NAME } from './constants';

export const dataLayerMiddleware =
    (store: Store<CheckoutState>) =>
    (next: Dispatch<CheckoutState>) =>
    (action: AnyAction) => {
        const state = store?.getState();
        const orderId = getOrderPersistentId(state);
        const eventId = getEventId(state);
        const { type, payload } = action;

        if (
            type == LOCATION_CHANGE &&
            payload?.pathname &&
            payload.pathname !== '/'
        ) {
            const destinationURL =
                getWindowObject('location').origin + payload.pathname;

            const page = {
                destinationURL,
                routerPayload: payload,
                ...(orderId && { orderId }),
                ...(eventId && { eventId }),
            };

            updatePageProps({
                page,
                eventName: DATALAYER_MIDDLEWARE_LOCATION_CHANGE_EVENT_NAME,
            });
        }

        return next(action);
    };
